<script>
import { Line } from 'vue-chartjs'
export default {
  extends: Line,
  props: {
    labels: Array,
    data: Array
  },
  mounted: function () {
    let max = 0
    this.data.map(d => {
      max = Math.max(max, d)
    })
    this.renderChart({
      labels: this.labels,
      datasets: [
        {
          label: '觀看次數',
          borderColor: '#FF6600',
          backgroundColor: '#FF6600',
          fill: false,
          data: this.data
        }
      ]
    },
    {
      maintainAspectRatio: true,
      scales: {
        yAxes: [{
          ticks: {
            min: 0,
            max: max + 1,
            stepSize: 1
          }
        }]
      }
    })
  }
}
</script>
